export default __webpack_public_path__ + "static/instagram-logo@3x-54689a7a62e07e167f8dc3312dca4821.png";